import React, { useEffect, useState } from "react";
import { MenuItemHeader, MenuItemIcon, StyledMenuItem } from "./styles";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import "tippy.js/themes/translucent.css";
import { NewMenuItemProps } from "./NewMenuItem";
import { IconPrefix, IconName } from "@fortawesome/fontawesome-svg-core";
import {
  Dot,
  SubMenuItemGrade,
  SubMenuItemHeader,
  SubMenuItemLi,
  SubMenuItemTitle,
  Title,
} from "./submenu-styles";

import Tippy from "@tippyjs/react";
import { followCursor } from "tippy.js";
import { setPickStatusColor } from "sharedKernel/statusColor";

export interface SubMenuItemProps extends NewMenuItemProps {
  subMenuItems?: NewSubMenuItemProps[];
  hideArrow?: boolean;
  hideSubMenu?: boolean;
  accordionOpen?: boolean;
  isTeiaHeader?: boolean;
}

export interface NewSubMenuItemProps extends NewMenuItemProps {
  fillPercentage?: number;
  grade?: number;
  tooltipContent?: string;
  isProfile?: boolean;
  subMenuIcon?: any;
  onGradeClick?: () => void;
}

export const NewSubMenuItem = ({
  active,
  disabled,
  path,
  icon,
  title,
  onClick = () => {},
  isSidebarOpen = true,
  isTeiaHeader = false,
  hideArrow = false,
  subMenuItems = [],
  hideSubMenu = false,
  accordionOpen,
}: SubMenuItemProps) => {
  const collapsed = !isSidebarOpen;
  const visibility = isSidebarOpen ? "visible" : "hidden";
  const arrowVisibility = !hideArrow ? "visible" : "hidden";
  const chevronRight: [IconPrefix, IconName] = ["fas", "chevron-right"];
  const chevronDown: [IconPrefix, IconName] = ["fas", "chevron-down"];
  const [isMenuItemOpen, setIsMenuItemOpen] = useState(false);
  useEffect(() => {
    if (!isSidebarOpen) {
      setIsMenuItemOpen(false);
    }
  }, [isSidebarOpen]);

  useEffect(() => {
    if (accordionOpen !== undefined) {
      setIsMenuItemOpen(accordionOpen);
    }
  }, [accordionOpen]);

  return (
    <>
      {!hideSubMenu && (
        <>
          <StyledMenuItem
            $collapsed={collapsed}
            onClick={() => {
              setIsMenuItemOpen(!isMenuItemOpen);
              onClick();
            }}
            className={`${active ? "active" : ""}`}
            isTeiaHeader={isTeiaHeader}
          >
            <MenuItemHeader
              $collapsed={collapsed}
              to={`${disabled ? "#" : `${path}`}`}
              className={`${active ? "active" : ""} ${
                disabled ? "disabled" : ""
              }`}
            >
              {!collapsed && visibility === "visible" && (
                <MenuItemIcon
                  style={{ visibility: arrowVisibility }}
                  icon={!isMenuItemOpen ? chevronRight : chevronDown}
                />
              )}
              {icon && <MenuItemIcon $collapsed={collapsed} icon={icon} />}
              {!collapsed && <Title>{title}</Title>}
            </MenuItemHeader>
          </StyledMenuItem>
          <div className="d-flex flex-column align-items-center gap-2 ">
            {isMenuItemOpen &&
              subMenuItems.map((subMenuItem, index) => {
                let tooltipMaxWidth = false;

                if (
                  subMenuItem.tooltipContent !== undefined &&
                  subMenuItem.tooltipContent !== ""
                ) {
                  subMenuItem.tooltipContent
                    ?.toString()
                    .split(" ")
                    .forEach((word) => {
                      if (word.length >= 35) {
                        tooltipMaxWidth = true;
                      }
                    });
                }

                return (
                  <>
                    <SubMenuItemLi
                      key={index}
                      className={`${subMenuItem.disabled ? "disabled" : ""}`}
                    >
                      <Tippy
                        content={subMenuItem.tooltipContent}
                        followCursor={true}
                        plugins={[followCursor]}
                        animation="scale"
                        arrow={false}
                        maxWidth={tooltipMaxWidth ? "100%" : "16rem"}
                        theme="primary"
                        allowHTML={true}
                      >
                        <div>
                          <SubMenuItemHeader
                            style={{
                              visibility: visibility,
                              marginLeft: "0px",
                            }}
                            to={`${
                              subMenuItem.disabled ? "#" : `${subMenuItem.path}`
                            }`}
                            className={`${
                              subMenuItem.disabled ? "disabled" : ""
                            }`}
                          >
                            {!subMenuItem.isProfile && (
                              <Dot
                                bgColor={setPickStatusColor(
                                  subMenuItem.fillPercentage ?? 0
                                )}
                              />
                            )}
                            {subMenuItem.isProfile && (
                              <MenuItemIcon icon={subMenuItem.subMenuIcon} />
                            )}
                            <SubMenuItemTitle grade={true}>
                              {subMenuItem.title}
                            </SubMenuItemTitle>
                          </SubMenuItemHeader>
                        </div>
                      </Tippy>
                      {!subMenuItem.isProfile && (
                        <Tippy
                          content={
                            subMenuItem.disabled
                              ? "Fora do período de avaliação"
                              : "Alterar avaliação"
                          }
                          followCursor={true}
                          plugins={[followCursor]}
                          animation="scale"
                          arrow={false}
                          maxWidth={tooltipMaxWidth ? "100%" : "16rem"}
                          theme="primary"
                          allowHTML={true}
                        >
                          <SubMenuItemGrade
                            onClick={(event) => {
                              event.preventDefault();
                              subMenuItem.onGradeClick?.();
                            }}
                          >
                            {subMenuItem.grade !== undefined
                              ? subMenuItem.grade.toFixed(2)
                              : 0}
                          </SubMenuItemGrade>
                        </Tippy>
                      )}
                    </SubMenuItemLi>
                  </>
                );
              })}
          </div>
        </>
      )}
    </>
  );
};
